import { render } from "./GiftCardFeeModal.vue?vue&type=template&id=4f342812"
import script from "./GiftCardFeeModal.vue?vue&type=script&lang=js"
export * from "./GiftCardFeeModal.vue?vue&type=script&lang=js"
script.render = render

export default script